// Phase APP-2 · Approve confirmation modal.
import { useState } from "react";
import { X, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../../../services/api";

const ORANGE = "#FF6B00";

export default function ApproveApprovalModal({ open, onClose, request, onDone }) {
  const [busy, setBusy] = useState(false);
  if (!open || !request) return null;
  const entityTitle = request.approval_type === "packer_request"
    ? "Packer Request" : "Micro Hub Suggestion";
  const entityName = (request.entity_payload || {}).name
                       || (request.entity_payload || {}).full_name
                       || request.display_name
                       || request.request_id;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post(`/approvals/${request.request_id}/approve`, {});
      const se = r.data?.side_effect || {};
      const newEntity = se.hub_id || se.user_id;
      toast.success(newEntity
                       ? `Approved — created ${newEntity}`
                       : "Approved.");
      onDone?.(r.data?.status);
      onClose?.();
    } catch (e2) {
      const detail = e2?.response?.data?.detail || e2?.message || "Failed";
      toast.error(typeof detail === "string" ? detail
                                                  : (detail.message || JSON.stringify(detail)));
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black/50 p-2"
         data-testid="approve-approval-modal" role="dialog" aria-modal="true">
      <form onSubmit={submit}
            className="bg-white w-full sm:max-w-sm rounded-2xl shadow-xl overflow-hidden">
        <div className="px-4 py-3 border-b border-slate-200 flex items-center gap-2">
          <h3 className="text-base font-semibold flex-1">Approve {entityTitle}</h3>
          <button type="button" onClick={onClose}
                  aria-label="Close" data-testid="approve-modal-close"
                  className="p-1.5 rounded-full hover:bg-slate-100">
            <X className="h-4 w-4"/>
          </button>
        </div>
        <div className="px-4 py-4 text-sm text-slate-700 space-y-2">
          <div>Approve <span className="font-semibold">{entityName}</span>?</div>
          <div className="text-xs text-slate-500">
            This will create the entity and notify the submitter.
          </div>
        </div>
        <div className="px-4 py-3 border-t border-slate-200 flex items-center justify-end gap-2">
          <button type="button" onClick={onClose}
                  data-testid="approve-modal-cancel"
                  className="text-sm px-3 py-2 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50">
            Cancel
          </button>
          <button type="submit" disabled={busy}
                  data-testid="approve-modal-submit"
                  className="text-sm font-semibold px-4 py-2 rounded-lg text-white disabled:opacity-50 inline-flex items-center gap-1.5"
                  style={{ backgroundColor: ORANGE }}>
            {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin"/> : <Check className="h-3.5 w-3.5"/>}
            Approve
          </button>
        </div>
      </form>
    </div>
  );
}
